@if (message()) {
  <div class="flex items-center gap-1.5 mt-1 text-xs text-talos-accent">
    <lucide-icon [img]="icon()" [size]="13" color="currentColor" class="shrink-0"></lucide-icon>
    <span>{{ message() }}</span>
  </div>
}
